var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('p',[_vm._v(" Ce numéro CNI est présent dans une demande déjà validée. ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }